export type MetricCardState = "ready" | "loading" | "unavailable";

type MetricCardProps = {
  title: string;
  value: string;
  note: string;
  state?: MetricCardState;
};

export default function MetricCard({ title, value, note, state = "ready" }: MetricCardProps) {
  if (state === "loading") {
    return (
      <section className="metric-card" aria-busy="true">
        <div className="skeleton skeleton-title" />
        <div className="skeleton skeleton-value" />
        <div className="skeleton skeleton-note" />
      </section>
    );
  }

  return (
    <section className={state === "unavailable" ? "metric-card unavailable-card" : "metric-card"}>
      <p className="card-title">{title}</p>
      <p className="card-value">{value}</p>
      <p className="card-note">{note}</p>
    </section>
  );
}
